import "./NewChatOptions.scss";

import { Paper, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import React from "react";
import { handleSendMessage } from "../redux/chatSlice";
import { messageSent } from "../segment/Events";

function NewChatOptions() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.chat.user);
  const bot = useSelector((state) => state.chat.bot);
  const prompts = useSelector((state) => state.chat.examplePrompts);

  return (
    <div className="new">
      <img src={bot.logo} alt={`${bot.name} Logo`} className="new-logo" />
      <Typography variant="h6" className="new-title">
        {bot.name}
      </Typography>
      <div className="new-tagline">{bot.newChatSubtext}</div>
      <div className="new-prompts">
        {prompts.map((prompt, idx) => (
          <div
            className="new-prompt"
            key={idx}
            onClick={() => {
              dispatch(
                handleSendMessage({ message: prompt.prompt, user, free: true })
              );
              messageSent(prompt.prompt, bot.id, true);
            }}
          >
            <div className="new-promptHeader">{prompt.header} </div>
            <Paper elevation={3} className="new-promptContent">
              {prompt.prompt}
            </Paper>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NewChatOptions;
